<h3>PROCEEDINGS</h3>
<a href="http://www.decifris.it/koine/articles-and-volumes" style="width: 40%; margin-left: 30%; margin-right: 30%;">
	<img src="../../../../../../assets/images/koine/Vol1: CIFRIS23 ACTA.png" style="width: 40%;">
</a>

<p>
	Each talk presented at De Cifris workshops will be published according to a choice made by the paper authors
	as follows:
</p>
<ol>
	<li>
		(either) <br>
		A two-page mini-abstract will appear in the main Proceedings book, which will be the first issue of a
		new book series <b>De Cifris Koine</b>. The paper will also appear in other forms freely: since the
		mini-abstract is only two-page long, its publication in <b>Koine</b> will not affect the publication of
		the full paper in other venues.
	</li>

	<li>
		(or) <br>
		A two-page mini-abstract will appear in the main Proceedings book, which will be the first issue of a
		new book series <b>De Cifris Koine</b>. The paper will also appear in a Special Issue of the
		internationally renowned journal <a href="https://www.degruyter.com/journal/key/jmc/html">
			Journal of Mathematical Cryptology
		</a> (JMC). Papers appearing in JMC will be refereed both by the workshop PC and by JMC board. There is
		no page limit for JMC, but a paper appearing in JMC <b>cannot</b> be published in other venues. All
		these JMC papers will be published Open Access but the fees are covered by De Cifris, so the authors
		will not pay anything.
	</li>

</ol>
<p>
	Remarks:
</p>
<ol type="A">
	<li>
		In any case, a two-page abstract <b>must</b> appear in <b>Koine</b>. Authors of accepted workshop talks
		are expected to send it to <a href="mailto:editorial@decifris.it">editorial&#64;decifris.it</a> not later
		than the 4-th of December.
	</li>

	<li>
		<b>Koine</b> is an Open Access publication, with <b>no fees</b> for authors. It is published by <b
			style="color:red;">De Cifris Press</b>, our own publishing house.
	</li>

	<li>
		<b>Koine</b> is a book series that will not be indexed by search engines, such as Scopus. Its books have
		only the goal of showing the activities of the Italian community.
	</li>

</ol>